import logo from '../assets/desktop/logo.svg'
import headerBackground from '../assets/desktop/bg-pattern-header.svg'
import headerBackgroundMobile from '../assets/mobile/bg-pattern-header.svg'
import sunIcon from '../assets/desktop/icon-sun.svg'
import moonIcon from '../assets/desktop/icon-moon.svg'
import locationIcon from '../assets/desktop/icon-location.svg'
import searchIcon from '../assets/desktop/icon-search.svg'
import searchIconWhite from '../assets/desktop/search-icon-white.png'
import filter from '../assets/mobile/icon-filter.svg'


export default {
    logo,
    headerBackground,
    headerBackgroundMobile,
    sunIcon,
    moonIcon,
    locationIcon,
    searchIcon,
    searchIconWhite,
    filter
}